<template>
  <div>
    <PaginatedTable
      ref="table"
      table="tactics"
      :table-class="Tactic"
      :filter-definitions="filterDefinitions"
      :headers="headers"
    >
      <template #right-actions>
        <v-btn
          aria-label="Import Tactics"
          color="secondary"
          class="mr-2"
          flat
          @click="importer.open()"
        >
          <v-icon>mdi-upload</v-icon>Import
        </v-btn>
      </template>

      <template #item.actions="{ item }">
        <v-btn
          aria-label="View Tactic"
          view="View"
          icon="mdi-eye"
          flat
          density="compact"
          @click="dialog?.open(item.id)"
        />
      </template>
    </PaginatedTable>
    <TacticImport ref="importer" @imported="table?.getData()" />
    <TacticDialog ref="dialog" @change="table?.getData()" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Tactic } from "@/classes";
import TacticDialog from "@/components/tactic/TacticDialog.vue";
import PaginatedTable from "@/components/base/tables/PaginatedTable.vue";
import { FilterDefinition } from "@/types/filter";
import { DataTableHeader } from "@/types/table";
import TacticImport from "@/components/tactic/TacticImport.vue";

const headers: DataTableHeader[] = [
  {
    title: "Maintenance Item",
    key: "maintenance_item",
    sortable: true,
  },
  {
    title: "Maintenance Item Desc.",
    key: "maintenance_item_description",
    sortable: true,
  },
  {
    title: "Func. Loc.",
    key: "functional_location",
    sortable: true,
  },
  {
    title: "Action",
    key: "actions",
    sortable: false,
  },
];

const filterDefinitions: FilterDefinition[] = [
  {
    label: "Maintenance Item",
    value: "maintenance_item",
    type: "string",
  },
  {
    label: "Maintenance Item Desc.",
    value: "maintenance_item_description",
    type: "string",
  },
  {
    label: "Func. Loc.",
    value: "functional_location",
    type: "string",
  },
];

const table = ref<InstanceType<typeof PaginatedTable> | null>(null);
const dialog = ref<InstanceType<typeof TacticDialog> | null>(null);
const importer = ref<InstanceType<typeof TacticImport> | null>(null);
</script>
